module.exports = __webpack_public_path__ + "7595678af188193cffb54f6570a066bc.MP3";